const englishTranslations = {
  px: {
    title: "Prescription",
    latest: "Latest Px",
    previous: "Previous Px",
    fetchingLatestPxMsg1: "Please wait.",
    fetchingLatestPxMsg2: "Doctor is sending you the prescription.",
    medicineHeader: "Medication Prescribed",
    morning: "Morning",
    afternoon: "Afternoon",
    night: "Night",
    evening: "Evening",
    instruction: "Instruction",
    duration: "Duration",
    followUpText: "Recommended follow up session with Doctor on ",
    spInstructionsHeader: "Special Instructions",
    spAdviceHeader: "Special Advice",
    testsTitle: "Prescribed Tests",
    fetchingTestsPxMsg2: "Doctor is sending you the medical test prescription.",
    bodyScanHeader: "Radiology Investigations",
    pathologyHeader: "Pathology Investigations",
    consultationTypeHeader: "Consultation Type",
    reportsFetchError: "Error occurred while fetching reports",
    reportsAvailable: "Your reports are available",
    viewReportsCTA: "View",
    pxUnavailable: "Prescription will be issued after you start using the app",
    pxFetchError: "Error occurred while fetching prescription",
    examinationHeader: "Examination Findings",
    procedureHeader: "Procedures",
  },
};

const marathiTranslations = {
  px: {
    title: "प्रिस्क्रिप्शन",
    latest: "चालू प्रिस्क्रिप्शन",
    previous: "मागील प्रिस्क्रिप्शन",
    fetchingLatestPxMsg1: "कृपया प्रतीक्षा करा.",
    fetchingLatestPxMsg2: "डॉक्टर तुम्हाला प्रिस्क्रिप्शन पाठवत आहेत.",
    medicineHeader: "लिहून दिलेली औषधे ",
    morning: "सकाळ",
    afternoon: "दुपारी",
    night: "रात्री",
    evening: "संध्या",
    instruction: "सूचना",
    duration: "Duration",
    followUpText: "डॉक्टरांसह फॉलो-अप सत्राची शिफारस केली जाते ",
    spInstructionsHeader: "विशेष सूचना",
    testsTitle: "लिहून दिलेल्या चाचण्या",
    fetchingTestsPxMsg2:
      "डॉक्टर तुम्हाला मेडिकल टेस्ट प्रिस्क्रिप्शन पाठवत आहेत.",
    bodyScanHeader: "बॉडी स्कॅन",
    pathologyHeader: "पॅथॉलॉजी तपासणी",

    noReports: "कोणतेही रिपोर्ट्स आढळले नाहीत.",
    reportsFetchError: "तांत्रिक बिघाडामुळे रिपोर्ट्स मिळाळूशकत नाही.",
    reportsAvailable: "तुमचे रिपोर्ट्स उपलब्ध आहेत",
    viewReportsCTA: "पहा",
    pxUnavailable:
      "तुम्ही अ‍ॅप वापरणे सुरू केल्यानंतर प्रिस्क्रिप्शन दिले जाईल",
    pxFetchError: "तांत्रिक बिघाडामुळे प्रिस्क्रिप्शन मिळाळूशकत नाही.",
  },
};

const hindiTranslations = {
  px: {
    title: "प्रिस्क्रिप्शन",
    latest: "प्रिस्क्रिप्शन",
    previous: "पिछला प्रिस्क्रिप्शन",
    fetchingLatestPxMsg1: "कृपया प्रतीक्षा कीजिये।",
    fetchingLatestPxMsg2: "डॉक्टर आपको प्रिस्क्रिप्शन भेज रहे हैं।",
    medicineHeader: "निर्धारित दवा",
    morning: "सुबह",
    afternoon: "दोपहर",
    night: "रात",
    evening: "शाम",
    instruction: "सूचना",
    duration: "Duration",
    followUpText: "डॉक्टर के साथ अनुवर्ती सत्र की सिफारिश की जाती है ",
    spInstructionsHeader: "विशेष सूचना",
    testsTitle: "निर्धारित टेस्ट",
    fetchingTestsPxMsg2: "डॉक्टर आपको मेडिकल टेस्ट की पर्ची भेज रहे हैं।",
    bodyScanHeader: "बॉडी स्कैन",
    pathologyHeader: "पैथोलॉजी जांच",

    noReports: "कोई रिपोर्ट नहीं मिली।",
    reportsFetchError: "तकनीकी खराबी के कारण रिपोर्ट नहीं मिल पा रही है।",
    reportsAvailable: "आपकी रिपोर्ट उपलब्ध हैं।",
    viewReportsCTA: "देखें",
    pxUnavailable:
      "आपके द्वारा ऐप का उपयोग शुरू करने के बाद प्रिस्क्रिप्शन प्रदान किया जाएगा",
    pxFetchError: "तकनीकी खराबी के कारण प्रिस्क्रिप्शन नहीं मिल पा रही है।",
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
